// extracted by mini-css-extract-plugin
export var backupIcon = "_su-1";
export var image = "_su-0";